function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClear = function SvgClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3,12a9,9 0 1,0 18,0a9,9 0 1,0 -18,0",
    fill: "#D8D8D8",
    fillRule: "evenodd",
    style: {
      fill: "#D8D8D8"
    }
  }));
};
export default SvgClear;